// extracted by mini-css-extract-plugin
export var avatarContainer = "_5u-1";
export var largeAvatarContainer = "_5u-2";
export var smallAvatarContainer = "_5u-0";